// Tabla page constants & filter-helpers. Extracted from Tabla.jsx so the
// page component focuses on layout/state, not data shape.

export const PAGE_SIZES = [25, 50, 100, 250];

export const COLUMNS = [
  { key: "timestamp", label: "common.date", filter: "date" },
  { key: "employee_id", label: "common.employee", filter: "employee" },
  { key: "transaction_type", label: "common.type", filter: "type" },
  { key: "item", label: "common.item", filter: "item" },
  { key: "qty", label: "common.qty", filter: "qty" },
  { key: "order_id", label: "common.order", filter: "order" },
];

export const TX_TYPES = ["RF PICK", "RF STAGE", "RF TRNS", "RF RCPT", "RF.RCVR", "RF LOAD"];

export const EMPTY_CF = {
  date_from: "",
  date_to: "",
  employee_search: "",
  employee_ids: [],
  transaction_types: [],
  item_search: "",
  qty_min: "",
  qty_max: "",
  order_search: "",
};

// Active-filter detection. We count keys instead of comparing to a deep-equal
// empty so that {qty_min: 0} still counts as a filter.
export function isActive(cf, keys) {
  if (!cf) return false;
  return keys.some((k) => {
    const v = cf[k];
    if (v == null || v === "") return false;
    if (Array.isArray(v)) return v.length > 0;
    return true;
  });
}

export function countActive(cf) {
  if (!cf) return 0;
  let n = 0;
  if (cf.date_from || cf.date_to) n++;
  if (cf.employee_search || (cf.employee_ids && cf.employee_ids.length)) n++;
  if (cf.transaction_types && cf.transaction_types.length) n++;
  if (cf.item_search) n++;
  const hasMin = cf.qty_min != null && cf.qty_min !== "";
  const hasMax = cf.qty_max != null && cf.qty_max !== "";
  if (hasMin || hasMax) n++;
  if (cf.order_search) n++;
  return n;
}
